import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { NgxPendoService } from "ngx-pendo";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";

import { AuthService } from "@core/services/auth.service";
import { getUserDataState } from "@store/index";
import { AppState } from "@store/models/state.model";
import { TabStateService } from "@shared/services/tab-state/tab-state.service";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit, OnDestroy {
	private destroy$ = new Subject<void>();

	private tabStateService = inject(TabStateService);
	private authService = inject(AuthService);
	private store = inject(Store<AppState>);
	private ngxPendoService = inject(NgxPendoService);

	ngOnInit(): void {
		this.authService.bootstrapAuthClient();
		this.authService.startKeepAlive();
		this.tabStateService.initialise();
		this.initialisePendo();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	private initialisePendo(): void {
		this.store
			.select(getUserDataState)
			.pipe(
				filter(userData => !!userData?.email),
				takeUntil(this.destroy$)
			)
			.subscribe(userData => {
				this.ngxPendoService.initialize(
					{
						id: userData.email as string,
						email: userData.email as string,
						name: `${userData.firstName ?? ""} ${userData.lastName ?? ""}`.trim(),
						role: (userData.roles ?? []).join(", ")
					},
					{
						id: userData.email as string
					}
				);
			});
	}
}
